import { useIntl } from '@redbubble/next/intl';
import { useMemo } from 'react';
import { messages } from '../../messages';
import { Indicator } from '../Indicator';

export interface FitIndicatorProps {
  indicatorValue: number;
  premium?: boolean;
}

export const FitIndicator = ({
  indicatorValue,
  premium,
}: FitIndicatorProps) => {
  const intl = useIntl();
  const getDescription = useMemo(() => {
    if (indicatorValue <= 4) {
      return messages.snugFitDescription;
    }
    if (indicatorValue <= 6) {
      return messages.standardFitDescription;
    }
    if (indicatorValue <= 8) {
      return messages.relaxedFitDescription;
    }
    if (indicatorValue <= 10) {
      return premium
        ? messages.premiumOversizedFitDescription
        : messages.oversizedFitDescription;
    }
    return messages.standardFitDescription;
  }, [indicatorValue, premium]);

  return (
    <Indicator
      value={indicatorValue}
      title={intl.formatMessage(messages.fitIndicatorTitle)}
      description={intl.formatMessage(getDescription)}
      minLegend={intl.formatMessage(messages.slim)}
      averageLegend={intl.formatMessage(messages.standard)}
      maxLegend={intl.formatMessage(messages.oversized)}
      minValue={1}
      maxValue={10}
    />
  );
};
